// Generated using https://react-svgr.com/
import * as React from 'react';

export interface SvgInfoIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

function SvgInfoIcon(props: SvgInfoIconProps) {
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={props.className}>
      <path
        d="M14.148 19h-1.835v-8.64h1.835V19zM12.203 8.07c0-.328.089-.58.266-.758.182-.177.44-.265.773-.265.323 0 .573.088.75.266.182.177.274.43.274.757 0 .313-.091.56-.274.742-.177.178-.427.266-.75.266-.333 0-.591-.088-.773-.265-.177-.183-.266-.43-.266-.743z"
        fill="#636366"
      />
      <circle cx={13} cy={13} r={12} stroke={props.color ?? '#636366'} strokeWidth={1.5} />
    </svg>
  );
}

export default SvgInfoIcon;
